(function () {
	const header = () => {
		const header = document.querySelector(".shopify-section-header");
		const menu = document.querySelector(".list-menu--inline");
		const menuLinks = document.querySelectorAll(".list-menu-item");
		const search = document.querySelector(".header__search");

		header.addEventListener("keydown", (e) => {
			if (e.code === "Escape" && search.isOpen) {
				search.close();
			}
		});

		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty("--vh", `${vh}px`);

		const annBar = document.querySelector(".section-announcement");
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries;

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					"--ann-height",
					`${entry.intersectionRect.height}px`,
				);
			} else {
				document.documentElement.style.setProperty("--ann-height", `0px`);
			}
		});
		if (annBar) annBarObserver.observe(annBar);

		menuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (e) => {
				if (link.classList.contains("list-menu--megamenu")) {
					link.classList.add("list-menu--megamenu-visible");
					if (
						header.classList.contains("color-background-3") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						// header.classList.remove("color-background-3");
					}

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove("list-menu--megamenu-visible");
						}
					});
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove("list-menu--megamenu-visible");
					});
				}
			});
		});
		menu.addEventListener("mouseleave", (e) => {
			menuLinks.forEach((link) => {
				link.classList.remove("list-menu--megamenu-visible");
			});
		});

		document.body.addEventListener('mousedown', function() {
			document.body.classList.add('mouse-focus');
		});

		document.body.addEventListener('keydown', function(e) {
				if (e.key === 'Tab') {
					document.body.classList.remove('mouse-focus');
				}
		});

		const addBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains("color-background-3") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						// header.classList.remove("color-background-3");
					}
				}
			});

			headerObserver.observe(header);
		};

		const removeBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains("color-background-1") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						// header.classList.add("color-background-3");
					}
				}
			});

			headerObserver.observe(header);
		};

		header.addEventListener("mouseenter", addBackground);

		header.addEventListener("focus", addBackground);

		header.addEventListener("focusin", addBackground);

		header.addEventListener("mouseleave", removeBackground);

		header.addEventListener("focusout", removeBackground);

		const megaMenuListLinks = () => {
			const megaMenuLinkWithSubmenu = document.querySelector(
				".mega-menu__list-item--children",
			);
			const megaMenuLinks = document.querySelectorAll(".mega-menu__list-item");
			if (megaMenuLinkWithSubmenu) {
				megaMenuLinks.forEach((link) => {
					link.classList.add("mega-menu__list-item--opacity");
				});
				megaMenuLinkWithSubmenu.classList.remove(
					"mega-menu__list-item--opacity",
				);
				megaMenuLinkWithSubmenu.classList.add("mega-menu__list-item--visible");
			}
			megaMenuLinks.forEach(function (item) {
				item.addEventListener("mouseenter", function (event) {
					if (megaMenuLinkWithSubmenu) {
						megaMenuLinkWithSubmenu.classList.remove(
							"mega-menu__list-item--visible",
						);
					}
					this.classList.remove("mega-menu__list-item--opacity");
					Array.from(this.parentElement.children).forEach(function (sib) {
						if (sib !== item) sib.classList.add("mega-menu__list-item--opacity");
					});
					this.addEventListener("mouseleave", function onLeave() {
						Array.from(item.parentElement.children).forEach(function (sib) {
							sib.classList.remove("mega-menu__list-item--opacity");
						});
						item.removeEventListener("mouseleave", onLeave);
					});
				});
				item.addEventListener("focus", function (event) {
					if (megaMenuLinkWithSubmenu) {
						megaMenuLinkWithSubmenu.classList.remove(
							"mega-menu__list-item--visible",
						);
					}
					this.classList.remove("mega-menu__list-item--opacity");
					Array.from(this.parentElement.children).forEach(function (sib) {
						if (sib !== item) sib.classList.add("mega-menu__list-item--opacity");
					});
					this.addEventListener("mouseleave", function onLeave() {
						Array.from(item.parentElement.children).forEach(function (sib) {
							sib.classList.remove("mega-menu__list-item--opacity");
						});
						item.removeEventListener("mouseleave", onLeave);
					});
				});
			});
		};

		const megaMenuSublinks = () => {
			document.querySelectorAll(".mega-menu--list .mega-menu__submenu-item").forEach(function (item) {
				item.addEventListener("mouseenter", function (event) {
					this.classList.remove("mega-menu__submenu-item--opacity");
					Array.from(this.parentElement.parentElement.children).forEach(function (sibList) {
						if (sibList !== item.parentElement) {
							sibList.querySelectorAll(".mega-menu__submenu-item").forEach(function (sib) {
								sib.classList.add("mega-menu__submenu-item--opacity");
							});
						}
					});
					this.addEventListener("mouseleave", function onLeave() {
						Array.from(item.parentElement.parentElement.children).forEach(function (sibList) {
							sibList.querySelectorAll(".mega-menu__submenu-item").forEach(function (sib) {
								sib.classList.remove("mega-menu__submenu-item--opacity");
							});
						});
						item.removeEventListener("mouseleave", onLeave);
					});
				});
				item.addEventListener("focusin", function (event) {
					this.classList.remove("mega-menu__submenu-item--opacity");
					Array.from(this.parentElement.parentElement.children).forEach(function (sibList) {
						if (sibList !== item.parentElement) {
							sibList.querySelectorAll(".mega-menu__submenu-item").forEach(function (sib) {
								sib.classList.add("mega-menu__submenu-item--opacity");
							});
						}
					});
					this.addEventListener("focusout", function onBlur() {
						Array.from(item.parentElement.parentElement.children).forEach(function (sibList) {
							sibList.querySelectorAll(".mega-menu__submenu-item").forEach(function (sib) {
								sib.classList.remove("mega-menu__submenu-item--opacity");
							});
						});
						item.removeEventListener("focusout", onBlur);
					});
				});
			});
		};
		megaMenuListLinks();
		megaMenuSublinks();

		const main = document.querySelector("main");
		const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
		if (
			main
				.querySelectorAll(".shopify-section")[0]?.classList.contains("section--has-overlay") &&
			!main
				.querySelectorAll(".shopify-section")[0]?.classList.contains("not-margin")
		) {
			header.classList.add("color-background-1", "color-background-3");
			if (breadcrumbs) {
				breadcrumbs.classList.add("color-background-3");
			}
		}
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();
